export default __webpack_public_path__ + "static/media/ambulance-management.92e8bccb.jpg";